import { getRequest, patchRequest, postRequest } from "./ApiRequest";

// App rapida del ristorante (backend `menucard/`): vini inseriti a mano, ricerca nel dataset, carte.
const M = "menucard";
export const GetMyWinesAPI = () => getRequest(`${M}/wines`);
export const SearchDatasetWinesAPI = (q) => getRequest(`${M}/wines/search?q=${encodeURIComponent(q)}`);
export const AddMyWineAPI = (payload) => postRequest(`${M}/wines`, payload);
export const UpdateMyWineAPI = (id, payload) => patchRequest(`${M}/wines/${id}`, payload);
// Vino che non e' nel dataset: foto dell'etichetta e/o dati base; l'AI li legge e l'amministratore approva.
export const RequestWineAPI = (formData) => postRequest(`${M}/wines/request`, formData);
